<template>
  <main-content with_go_back_bar>
    <ul class="nav nav-pills bg-white" role="tablist">
      <li class="nav-item">
        <button
          :class="['nav-link', activeTab === 'account-discrepancy-status' ? 'active' : '']"
          @click="setActiveTab('account-discrepancy-status')"
        >
          {{ $t("accounting.label.bank_discrepancy_status") }}
        </button>
      </li>
      <li class="nav-item">
        <button
            :class="['nav-link', activeTab === 'transactions-discrepancy-list' ? 'active' : '']"
            @click="setActiveTab('transactions-discrepancy-list')"
        >
          {{ $t("accounting.label.transactions-discrepancy-list") }}
        </button>
      </li>
        <li class="nav-item">
            <button
                :class="['nav-link', activeTab === 'records-discrepancy-list' ? 'active' : '']"
                @click="setActiveTab('records-discrepancy-list')">
                {{ $t("accounting.label.records-discrepancy-list") }}
            </button>
        </li>
    </ul>

    <div class="tab-content">
      <kt-datatable
        v-if="activeTab === 'account-discrepancy-status'"
        v-bind="dicrepancyStatusDatatable"
        ref="discrepancyStatusData"
      >
      </kt-datatable>
    </div>

    <div class="tab-content">
      <div v-if="activeTab === 'transactions-discrepancy-list'">
        <discrepancy-filter :action="filterAction" :query="query_filter" :type="'pf'" />
      </div>

      <kt-datatable
        v-if="activeTab === 'transactions-discrepancy-list'"
        v-bind="transactionsWithDiscrepancyDatatable"
        ref="transactionsWithDiscrepancyTable"
      >
      </kt-datatable>
    </div>

    <div class="tab-content">
      <div v-if="activeTab === 'records-discrepancy-list'">
          <discrepancy-filter :action="filterRecordsAction" :query="query_records_filter" :type="'starshop'" />
      </div>

      <kt-datatable
          v-if="activeTab === 'records-discrepancy-list'"
          v-bind="recordsWithDiscrepancyDatatable"
          ref="recordsWithDiscrepancyDatatable"
      >
      </kt-datatable>
    </div>
  </main-content>
</template>

<script>
import MainContent from "@/components/main-content.vue";
import {ApiUrl} from "@/common/api.service";
import { AuthorizationHeader } from "@/common/jwt.service";
import dicrepancyColumn from "./datatable/dicrepancyColumn";
import DiscrepancyActionColumn from "./components/discrepancy-action-column.vue";
import transactionsWithDiscrepancyColumn from "./datatable/transactionsWithDiscrepancyColumn";
import DiscrepancyFilter from "./components/discrepancy-filter.vue";
import DiscrepancyTransactionActionColumn from "./components/discrepancy-transaction-action-column.vue";
import DiscrepancySystemTransactionActionColumn from "@/views/accounting/components/discrepancy-system-transaction-action-column.vue";

export default {
  name: "AccountDiscrepancy",
  components: { MainContent, DiscrepancyFilter },
  data() {
    return {
      query_filter: {},
      query_records_filter: {},
      query_account_filter: {},
      account_hashid: null,
      activeTab: "account-discrepancy-status", // Default active tab
    };
  },

  computed: {
    dicrepancyStatusDatatable() {
      return {
        id: "accounting_account_discrepancy",
        data: {
          type: "remote",
          source: {
            read: {
              url: ApiUrl.path("accounting/admin/discrepancies"),
              method: "GET",
              headers: AuthorizationHeader,
              map: (res) => res.data.data,
              params: {
                query: this.query_account_filter,
              },
            },
          },
          pageSize: 15,
          serverPaging: true,
          serverFiltering: false,
          serverSorting: true,
        },
        pagination: false,
        sortable: false,
        columns: [...dicrepancyColumn],
        actions: DiscrepancyActionColumn,
      };
    },

    transactionsWithDiscrepancyDatatable() {
      return {
        id: "accounting_account_discrepancies_transactions",
        data: {
          type: "remote",
          source: {
            read: {
              url: ApiUrl.path("accounting/admin/transactions/discrepancies"),
              method: "GET",
              headers: AuthorizationHeader,
              map: (res) => res.data.data,
              params: this.query_filter, // Ensure this is included
            },
          },
          pageSize: 15,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        },
        pagination: false,
        sortable: false,
        columns: [...transactionsWithDiscrepancyColumn],
        actions: DiscrepancySystemTransactionActionColumn,
      };
    },
    recordsWithDiscrepancyDatatable() {
      return {
        id: "accounting_account_discrepancies_records",
        data: {
          type: "remote",
          source: {
            read: {
              url: ApiUrl.path("accounting/admin/records/discrepancies"),
              method: "GET",
              headers: AuthorizationHeader,
              map: (res) => res.data.data,
              params: this.query_records_filter
            },
          },
          pageSize: 15,
          serverPaging: true,
          serverFiltering: true,
          serverSorting: true,
        },
        pagination: false,
        sortable: false,
        columns: [...transactionsWithDiscrepancyColumn],
        actions: DiscrepancyTransactionActionColumn,
      };
    },
  },

  methods: {
    setActiveTab(tabName) {
      this.activeTab = tabName;
    },
    filterRecordsAction(e, query) {
      this.query_records_filter = query;
      this.$refs.recordsWithDiscrepancyDatatable.reload();
    },
    filterAction(e, query) {
      this.query_filter = query;
      this.$refs.transactionsWithDiscrepancyTable.reload(); 
    },
  },

  watch: {
    selectedRows: {
      handler(newVal) {
        console.log('Selected rows changed:', newVal);
      },
      deep: true, // Watch for changes in nested objects
    },
  },
};
</script>

<style scoped></style>